module.exports = __webpack_public_path__ + "img/Sound Decision Maker.a6756832.svg";